import React from 'react';

import ScoreColor from '../../modules/score_color.js';
import GradeColor, { RED, ORANGE, GREEN, BLUE } from '../../modules/grade_color.js';

const ResultsIcon = ({ activityType, percentage, }) => {
  const backgroundColor = () => {
    if (activityType === 'diagnostic') {
      return { backgroundColor: '#4D8DD9'} // $quill-blue
    }

    const scoreColor = ScoreColor(percentage * 100);
    let color = '#4ea500';
    if (scoreColor === 'red-score-color') {
      color = '#e73030';
    } else if (scoreColor === 'orange-score-color') {
      color = '#eb9911';
    }
    return { backgroundColor: color };
  }

  const imageSrc = () => {
    let img;
    switch (activityType) {
      case 'connect':
        img = 'tool-connect-white.svg'
        break;
      case 'sentence':
        img = 'tool-grammar-white.svg'
        break;
      case 'diagnostic':
        img = 'tool-diagnostic-white.svg'
        break;
      case 'evidence':
        img = 'tool-evidence-white.svg'
        break;
      default:
        img = 'tool-proofreader-white.svg'
    }
    return `${window.postbuildEnv.CDN_URL}/images/icons/s/${img}`
  }

  function getProficiencyText(color) {
    switch (color) {
      case RED:
        return 'showing rarely demonstrated skill'
      case ORANGE:
        return 'showing sometimes demonstrated skill'
      case GREEN:
        return 'showing frequently demonstrated skill'
      case BLUE:
        return 'showing activity completion'
      default:
        return ''
    }
  }

  function getAltText() {
    const color = GradeColor(percentage)
    switch (activityType) {
      case 'connect':
        return `Quill Connect icon with ${color} background ${getProficiencyText(color)}`
      case 'sentence':
        return `Quill Grammar icon with ${color} background ${getProficiencyText(color)}`
      case 'diagnostic':
        return `Quill Diagnostic icon with ${color} background ${getProficiencyText(color)}`
      case 'evidence':
        return `Quill Evidence icon with ${color} background ${getProficiencyText(color)}`
      default:
        return `Quill Proofreader icon with ${color} background ${getProficiencyText(color)}`
    }
  }

  return (
    <div className="results-icon-container">
      <div className='icon' style={backgroundColor()}>
        <img alt={getAltText()} src={imageSrc()} />
      </div>
    </div>
  )
}


export default ResultsIcon
